import React from 'react';
import MainContent from './component/MainContent/MainContent';
import './App.css';
import './assets/colors.css';

const App = () => {
  return <MainContent />;
};

export default App;
